import {Injectable} from '@angular/core';
import {EventEmitter} from '@angular/core';

@Injectable()
export class MsgPopupService {
    msgEvent: EventEmitter<any> = new EventEmitter();
    constructor() {
        this.msgEvent = new EventEmitter();
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/src/msg-popup.service.ts